import { AUTH_TYPE, MATERIAL_VIP_VERSION } from "@/constants/gaodingVip";
import { getVipTypeById, getVipTypeByUser } from "@/constants/vip";
import useAppStore from "@/context/store";
import { getGdVipInfo, updateCert } from "@/services";
import { isGdMerged } from "@/utils/gaoding";
import { filterMaterailVip } from "@/utils/gaodingVip";
import useReq from "@/utils/useReq";
import { useCallback, useRef, useState } from "react";
import HBMessage from "../HBMessage";
import HBModal from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import SubjectConfirm from "../Vip/subjectConfirm";
import AuthSubject from "./form";
import styles from "./index.module.less";

/**
 *
 * @param {{
 *    vipId?: string,
 *    certSubject?: CERTSubject,
 *    onOk?: Function,
 *    onCancel?: Function,
 * } & Partial<Parameters<AuthSubject>[0]> & import("antd").ModalProps} param
 * @returns
 */
function Dialog({ vipId, certSubject, onOk, onCancel, ...props }) {
  const [step, setStep] = useState(0);
  const subject = useRef(certSubject?.subject_info || {});

  const user = useAppStore((store) => store.user);

  const { data: { certType, isBigCompany } = {}, loading } = useReq(
    async () => {
      if (isGdMerged(user)) {
        const info = await getGdVipInfo();

        const materialVip = filterMaterailVip(info.vip)[0];

        const version = MATERIAL_VIP_VERSION[materialVip.solution_version];

        return {
          certType: version.certType,
          isBigCompany: version.authType === AUTH_TYPE.BIG_COMPANY,
        };
      } else {
        let vipType = getVipTypeByUser(user);
        // 当有vipId时，根据vipId获取vipType， user信息更新不及时
        if (vipId) {
          vipType = getVipTypeById(vipId);
        }

        return {
          certType:
            vipType === "company" || vipType === "bigCompany"
              ? "company"
              : "personal",
          isBigCompany: vipType === "bigCompany",
        };
      }
    },
    {
      refreshDeps: [user],
    }
  );

  const onSubmit = useCallback(async (data) => {
    subject.current = data;
    setStep(1);
  }, []);

  const onConfirm = useCallback(async () => {
    const result = await updateCert({
      id: certSubject.id,
      subject: subject.current,
    });

    if (result.err) return;

    HBMessage.success("提交成功");
    onOk && onOk();
  }, [certSubject.id, onOk]);

  if (loading) {
    return null;
  }

  return (
    <HBModal
      title={step === 0 ? "填写被授权方" : "授权信息确认"}
      width={580}
      wrapClassName={styles.modal}
      footer={null}
      onCancel={onCancel}
      {...props}
    >
      {step === 0 ? (
        <AuthSubject
          initValue={subject.current}
          type={certType}
          isBigCompany={isBigCompany}
          onSubmit={onSubmit}
          onCancel={onCancel}
          footerStyle={{
            justifyContent: "flex-end",
            paddingBottom: 24,
          }}
        />
      ) : (
        // 因为临时提的要有确认信息，所以这个组件不在同一文件夹内
        <SubjectConfirm
          noTitle
          width={420}
          subject={subject.current}
          onOk={onConfirm}
          onBack={() => {
            setStep(0);
          }}
          footerStyle={{
            justifyContent: "flex-end",
            margin: "24px 0",
          }}
        />
      )}
    </HBModal>
  );
}

const AuthSubjectDialog = ModalWrap(Dialog);

export default AuthSubjectDialog;
